<script>
  export default {
    name: 'UseMode',
    components: {
      CommonMode: () => import('./CommonMode.vue'),
    },
    props: {
      type: {
        type: String,
        required: true,
        default: 'spreadsheet',
      },
      integration: {
        type: Object,
        required: true,
      },
      items: {
        type: Array,
        default: () => [],
      },
    },
    data: () => ({
      selected: null,
    }),
    mounted() {
      if (this.integration.itemId) {
        this.selected = this.integration.itemId
      }
    },
    methods: {
      saveInfo(commonValues) {
        this.$emit('save-info', {
          selected: this.selected,
          ...commonValues,
        })
      },
    },
  }
</script>

<template>
  <div class="form-integrarion-container--wrapper">
    <h5 class="form-integrarion-text">
      Spreadsheets name
      <span class="red--text">*</span>
    </h5>
    <v-autocomplete
      v-model="selected"
      :items="items"
      item-text="name"
      item-value="id"
      label="Select a spreadsheet"
      outlined
      dense
      required
      clearable
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              No spreadsheets found
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
    <CommonMode
      :type="type"
      :integration="integration"
      @save-info="saveInfo"
    />
  </div>
</template>

<style lang="scss">
  .form-integrarion-container--wrapper h5 {
    margin-bottom: 10px;
  }

  .form-integrarion-title {
    color: var(--v-grey_3-base);
    font-size: 12px;
    font-weight: 400;
  }

  .form-integrarion-text {
    color: var(--v-gray_700-base);
    font-size: 16px;
    font-weight: 500;
  }
</style>
